import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';

const LegalLayout = ({ title, subtitle, children }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ direction: 'rtl', bgcolor: '#fcfbfa', minHeight: '100vh' }}>

      {/* Top bar */}
      <Box sx={{
        borderBottom: '1px solid rgba(30,58,95,0.08)',
        px: { xs: 3, md: 6 },
        py: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        bgcolor: 'white',
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}>
        <Box
          onClick={() => navigate('/')}
          sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
        >
          <Box
            component="img"
            src="/inorai-logo.png"
            alt="inorai"
            sx={{ width: 36, height: 36, objectFit: 'contain' }}
          />
          <Typography sx={{
            fontFamily: 'Secular One, sans-serif',
            fontSize: '1.1rem',
            color: '#1e3a5f',
          }}>
            inorai
          </Typography>
        </Box>

        <Button
          onClick={() => navigate('/')}
          sx={{
            color: '#5a6978',
            fontFamily: 'Heebo, sans-serif',
            fontSize: '0.85rem',
            textTransform: 'none',
            '&:hover': { color: '#1e3a5f' },
          }}
        >
          ← חזרה לדף הבית
        </Button>
      </Box>

      {/* Header */}
      <Box sx={{
        bgcolor: '#1e3a5f',
        py: { xs: 6, md: 8 },
        px: { xs: 3, md: 6 },
        textAlign: 'center',
      }}>
        <Typography sx={{
          fontFamily: 'Frank Ruhl Libre, serif',
          color: 'white',
          fontSize: { xs: '1.8rem', md: '2.4rem' },
          fontWeight: 900,
          letterSpacing: '-0.02em',
          mb: 1,
        }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography sx={{
            fontFamily: 'Heebo, sans-serif',
            color: 'rgba(255,255,255,0.5)',
            fontSize: '0.9rem',
          }}>
            {subtitle}
          </Typography>
        )}
      </Box>

      {/* Content */}
      <Box sx={{
        maxWidth: '760px',
        mx: 'auto',
        px: { xs: 3, md: 4 },
        py: { xs: 6, md: 8 },
      }}>
        {children}
      </Box>

      {/* Footer */}
      <Box sx={{
        borderTop: '1px solid rgba(30,58,95,0.08)',
        py: 3,
        px: { xs: 3, md: 6 },
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 2,
        bgcolor: 'white',
      }}>
        <Typography sx={{
          fontFamily: 'Heebo, sans-serif',
          fontSize: '0.8rem',
          color: '#a0a9b4',
        }}>
          © 2025 inorai · כל הזכויות שמורות
        </Typography>
        <Box sx={{ display: 'flex', gap: 3 }}>
          {[
            { label: 'תנאי שימוש', path: '/terms' },
            { label: 'מדיניות פרטיות', path: '/privacy' },
            { label: 'צור קשר', path: '/contact' },
          ].map(({ label, path }) => (
            <Typography
              key={label}
              onClick={() => navigate(path)}
              sx={{
                fontFamily: 'Heebo, sans-serif',
                fontSize: '0.8rem',
                color: '#8a94a0',
                cursor: 'pointer',
                '&:hover': { color: '#1e3a5f' },
              }}
            >
              {label}
            </Typography>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default LegalLayout;
